import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Output } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-rotation-message',
    template: `
        <span class="icon"><i class="theme-mobile"></i></span>
        <span>{{ landscapeMessage }}</span>
        <a class="theme-ex msg-close" (click)="closed()"></a>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RotationMessageComponent {
    @HostBinding('class') className = 'rotation-message-container';
    @Output() close = new EventEmitter<void>();

    constructor(private sitecore: Sitecore) {
        this.landscapeMessage = this.sitecore.globalMessages.NoRotationText;
    }

    landscapeMessage: string;

    closed(): void {
        this.close.emit();
    }
}
